import { useRef, useState } from "react";
import { toast } from "sonner";
import { UploadSimple, ImageSquare, X, Eye } from "@phosphor-icons/react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const fileUrl = (path) => (path ? `${BACKEND}/api/files/${path}` : "");

export function ImageUpload({ value, onChange, testId }) {
  const [loading, setLoading] = useState(false);
  const inputRef = useRef();

  const handle = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (!f.type.startsWith("image/")) return toast.error("Selecciona una imagen");
    setLoading(true);
    const fd = new FormData();
    fd.append("file", f);
    try {
      const { data } = await api.post("/upload", fd);
      onChange(data.path);
      toast.success("Foto subida");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sm:col-span-2">
      <input ref={inputRef} type="file" accept="image/*" className="hidden" data-testid={testId} onChange={handle} />
      {value ? (
        <div className="relative w-full h-44 rounded-sm overflow-hidden border border-border group">
          <img src={fileUrl(value)} alt="Foto del inmueble" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2">
            <Button type="button" size="sm" variant="secondary" className="rounded-sm" onClick={() => inputRef.current?.click()}>Cambiar</Button>
            <Button type="button" size="sm" variant="destructive" className="rounded-sm gap-1" onClick={() => onChange("")}><X size={14} /> Quitar</Button>
          </div>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={loading}
          className="w-full h-32 rounded-sm border border-dashed border-border flex flex-col items-center justify-center gap-2 text-muted-foreground hover:border-primary hover:text-primary transition-colors"
        >
          {loading ? <span className="text-sm">Subiendo…</span> : (<><UploadSimple size={24} /><span className="text-sm">Subir foto del inmueble</span></>)}
        </button>
      )}
    </div>
  );
}

export function Thumb({ path, alt }) {
  if (!path) return <div className="w-12 h-9 rounded-sm bg-secondary flex items-center justify-center text-muted-foreground"><ImageSquare size={16} /></div>;
  return <img src={fileUrl(path)} alt={alt} className="w-12 h-9 rounded-sm object-cover border border-border" />;
}

export function SingleUpload({ value, onChange, label = "Comprobante", testId }) {
  const [loading, setLoading] = useState(false);
  const ref = useRef();
  const handle = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setLoading(true);
    const fd = new FormData();
    fd.append("file", f);
    try {
      const { data } = await api.post("/upload", fd);
      onChange(data.path);
      toast.success("Comprobante subido");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
      if (ref.current) ref.current.value = "";
    }
  };
  return (
    <div>
      <label className="text-xs font-medium">{label}</label>
      <input ref={ref} type="file" className="hidden" data-testid={testId} onChange={handle} />
      <div className="mt-1 flex items-center gap-2">
        {value ? (
          <>
            <a href={fileUrl(value)} target="_blank" rel="noreferrer" className="text-sm text-primary hover:underline flex items-center gap-1"><Eye size={14} /> Ver comprobante</a>
            <button type="button" className="text-red-600" onClick={() => onChange("")}><X size={14} /></button>
          </>
        ) : (
          <Button type="button" variant="outline" size="sm" className="rounded-sm gap-2" disabled={loading} onClick={() => ref.current?.click()}>
            <UploadSimple size={14} /> {loading ? "Subiendo…" : "Subir comprobante"}
          </Button>
        )}
      </div>
    </div>
  );
}
